module.exports = __webpack_public_path__ + "img/radius-upright.c8e91adb.svg";